import { Alert, Box, Text } from 'braid-design-system';

import type { Partner } from 'src/types';
import { makePartnerImageUrl } from 'src/utils/partners/makePartnerImageUrl';

import { HtmlParser } from './HtmlParser';

interface Props {
  partner: Partner;
}

export const SelectedState = ({ partner }: Props) => {
  if (!partner.releaseNotes?.length) {
    return (
      <Alert tone="caution">
        <Text>
          {partner.name} has not added release notes yet. Please check back
          another time.
        </Text>
      </Alert>
    );
  }
  return (
    <>
      {partner.releaseNotesImageUrl && (
        <Box paddingBottom="gutter">
          <img
            src={`${makePartnerImageUrl(partner.releaseNotesImageUrl)}`}
            alt={`${partner.name} logo`}
            style={{
              width: 'auto',
              maxHeight: '90px',
              maxWidth: '100%',
            }}
          />
        </Box>
      )}
      <HtmlParser html={partner.releaseNotes} />
    </>
  );
};
